// extracted by mini-css-extract-plugin
export default {"tableHeader":"NUQzpGb_YAAYRzvQNLa4","infoCell":"UCV0Awp8jeD8rhUqzO00"};